// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"73":"b3ca9d96","143":"b3ca9d96","156":"b3ca9d96","172":"b3ca9d96","337":"b3ca9d96","554":"fa6eda1a","620":"b3ca9d96","635":"b3ca9d96","661":"b3ca9d96","709":"b3ca9d96","866":"b3ca9d96","945":"b3ca9d96"}[chunkId] + ".css";
};